import { type MonthKey, useStoredMonth } from '@horof/shared';
import { createContext, type ReactNode, useContext, useState } from 'react';

export type ListFilter = 'unread' | 'read' | 'all';

type RoundState = {
  month: MonthKey;
  setMonth: (month: MonthKey) => void;
  search: string;
  setSearch: (search: string) => void;
  filter: ListFilter;
  setFilter: (filter: ListFilter) => void;
};

const Context = createContext<RoundState | null>(null);
/** List state kept while moving between the round and a meter. */
export function RoundStateProvider({ children }: { children: ReactNode }) {
  const [month, setMonth] = useStoredMonth('readings.month');
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState<ListFilter>('unread');

  return (
    <Context.Provider
      value={{ month, setMonth, search, setSearch, filter, setFilter }}
    >
      {children}
    </Context.Provider>
  );
}

export function useRoundState(): RoundState {
  const state = useContext(Context);
  if (!state) throw new Error('useRoundState outside RoundStateProvider');
  return state;
}
